import { adfox } from './adfox';

export const tradingDesk = {
  adfox,
};
